module.exports = __webpack_public_path__ + "img/fiveE.774433db.jpg";